import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  takeFromkqlcz7c6dx2r as takeFrom,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Parameters.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { checkBuilderCapacity1h6g02949wvv as checkBuilderCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultRequest_kt__yzsodq();
  return LOGGER;
}
var LOGGER;
function defaultRequest(_this__u8e3s4, block) {
  _init_properties_DefaultRequest_kt__yzsodq();
  var tmp = Plugin_getInstance();
  return _this__u8e3s4.z5n(tmp, ($this$install) => {
    block($this$install);
    return Unit_instance;
  });
}
function mergeUrls($this, baseUrl, requestUrl) {
  if (requestUrl.i59_1 == null) {
    requestUrl.i59_1 = baseUrl.d5a_1;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = requestUrl.f59_1;
  if (charSequenceLength(this_0) > 0)
    return Unit_instance;
  var resultUrl = URLBuilder(baseUrl);
  // Inline function 'kotlin.with' call
  resultUrl.i59_1 = requestUrl.i59_1;
  if (!(requestUrl.h59_1 === 0)) {
    resultUrl.n5a(requestUrl.h59_1);
  }
  resultUrl.m59_1 = concatenatePath(Plugin_getInstance(), resultUrl.m59_1, requestUrl.m59_1);
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_1 = requestUrl.l59_1;
  if (charSequenceLength(this_1) > 0) {
    resultUrl.l59_1 = requestUrl.l59_1;
  }
  // Inline function 'kotlin.apply' call
  var this_2 = ParametersBuilder();
  appendAll(this_2, resultUrl.n59_1);
  var defaultParameters = this_2;
  resultUrl.a5b(requestUrl.n59_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = defaultParameters.n4t().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = element.m3();
    // Inline function 'kotlin.collections.component2' call
    var values = element.n3();
    if (!resultUrl.n59_1.n4s(key)) {
      resultUrl.n59_1.o4t(key, values);
    }
  }
  takeFrom(requestUrl, resultUrl);
}
function concatenatePath($this, parent, child) {
  if (child.n1())
    return parent;
  if (parent.n1())
    return child;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = first(child);
  if (charSequenceLength(this_0) === 0)
    return child;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  var capacity = (parent.q2() + child.q2() | 0) - 1 | 0;
  checkBuilderCapacity(capacity);
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList().h2(capacity);
  var inductionVariable = 0;
  var last = parent.q2() - 1 | 0;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_1.i2(parent.r2(index));
    }
     while (inductionVariable < last);
  this_1.u2(child);
  return this_1.f8();
}
var DefaultRequest$Plugin$install$slambdaClass;
function DefaultRequest$Plugin$install$slambda() {
  if (DefaultRequest$Plugin$install$slambdaClass === VOID) {
    class $ {
      constructor($plugin) {
        this.z5s_1 = $plugin;
      }
      *n5l($this$intercept, it, $completion) {
        var originalUrlString = $this$intercept.x4w_1.q5n_1.toString();
        // Inline function 'kotlin.apply' call
        var this_0 = new (DefaultRequestBuilder())();
        appendAll(this_0.a5t_1, $this$intercept.x4w_1.s5n_1);
        var userHeaders = this_0.a5t_1.l38();
        this.z5s_1.d5t_1(this_0);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = userHeaders.n4t().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          $l$block_0: {
            // Inline function 'kotlin.collections.component1' call
            var key = element.m3();
            // Inline function 'kotlin.collections.component2' call
            var oldValues = element.n3();
            var newValues = this_0.a5t_1.t4t(key);
            if (newValues == null) {
              this_0.a5t_1.o4t(key, oldValues);
              break $l$block_0;
            }
            if (equals(newValues, oldValues) || key === 'Cookie') {
              break $l$block_0;
            }
            this_0.a5t_1.b4u(key);
            this_0.a5t_1.o4t(key, oldValues);
            this_0.a5t_1.a4u(key, newValues);
          }
        }
        var defaultRequest = this_0;
        var defaultUrl = defaultRequest.b5t_1.l38();
        mergeUrls(Plugin_getInstance(), defaultUrl, $this$intercept.x4w_1.q5n_1);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = defaultRequest.c5t_1.q4r().p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (!$this$intercept.x4w_1.v5n_1.l4r(element_0)) {
            $this$intercept.x4w_1.v5n_1.m4r(element_0 instanceof AttributeKey() ? element_0 : THROW_CCE(), defaultRequest.c5t_1.j4r(element_0));
          }
        }
        $this$intercept.x4w_1.s5n_1.a5();
        $this$intercept.x4w_1.s5n_1.y4t(defaultRequest.a5t_1.l38());
        get_LOGGER().b4y('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + $this$intercept.x4w_1.q5n_1.toString());
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.n5l(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    DefaultRequest$Plugin$install$slambdaClass = $;
  }
  return DefaultRequest$Plugin$install$slambdaClass;
}
function DefaultRequest$Plugin$install$slambda_0($plugin) {
  var i = new (DefaultRequest$Plugin$install$slambda())($plugin);
  var l = ($this$intercept, it, $completion) => i.n5l($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'DefaultRequest';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(DefaultRequest());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(DefaultRequest()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.e5t_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.e5t_1;
      }
      f5t(block) {
        return new (DefaultRequest())(block);
      }
      x5n(block) {
        return this.f5t(block);
      }
      g5t(plugin, scope) {
        var tmp = Phases_getInstance().f5s_1;
        scope.u5l_1.b4x(tmp, DefaultRequest$Plugin$install$slambda_0(plugin));
      }
      y5n(plugin, scope) {
        return this.g5t(plugin instanceof DefaultRequest() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var DefaultRequestBuilderClass;
function DefaultRequestBuilder() {
  if (DefaultRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.a5t_1 = new (HeadersBuilder())();
        this.b5t_1 = new (URLBuilder_0())();
        this.c5t_1 = AttributesJsFn(true);
      }
      b56() {
        return this.a5t_1;
      }
      h5t(urlString) {
        takeFrom_0(this.b5t_1, urlString);
      }
    }
    initMetadataForClass($, 'DefaultRequestBuilder');
    DefaultRequestBuilderClass = $;
  }
  return DefaultRequestBuilderClass;
}
var DefaultRequestClass;
function DefaultRequest() {
  if (DefaultRequestClass === VOID) {
    class $ {
      constructor(block) {
        Plugin_getInstance();
        this.d5t_1 = block;
      }
    }
    initMetadataForClass($, 'DefaultRequest');
    DefaultRequestClass = $;
  }
  return DefaultRequestClass;
}
var properties_initialized_DefaultRequest_kt_au5efk;
function _init_properties_DefaultRequest_kt__yzsodq() {
  if (!properties_initialized_DefaultRequest_kt_au5efk) {
    properties_initialized_DefaultRequest_kt_au5efk = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
  }
}
//region block: exports
export {
  defaultRequest as defaultRequest2ux1d5xxixv6z,
};
//endregion

//# sourceMappingURL=DefaultRequest.mjs.map
